import { useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTheme } from '@/App';
import { defaultColors } from '@/themes/antd-theme';
import ProductionScheduler from './ProductionScheduler';

// ==============================|| MASTER & LOT PAGE ||============================== //

function MasterLotPage({ openCreate = false }) {
  const { isDark } = useTheme();
  const [searchParams] = useSearchParams();
  const demandId = searchParams.get('demandId');
  const createFromQuery = searchParams.get('create') === '1';

  return (
    <div
      className="p-2.5 pt-5"
      style={{ backgroundColor: isDark ? defaultColors.palette.gray[900] : '#f9fafb' }}
    >
      <ProductionScheduler
        initialDemandId={demandId}
        initialCreateOpen={openCreate || createFromQuery}
      />
    </div>
  );
}

MasterLotPage.propTypes = {
  openCreate: PropTypes.bool,
};

export default MasterLotPage;
